<!-- <p>energy-dashboard works!</p> -->
<div class="dashboard-container">
    <ejs-dashboardlayout id='dashboardLayout' #dashboardLayout [columns]="8" #editLayout [cellSpacing]='cellSpacing'
        [allowResizing]='false' [cellAspectRatio]='aspectRatio' [allowDragging]="false" [mediaQuery]="mediaQuery">
        <div class="e-panel" data-row="0" data-col="0" data-sizeX="4" data-sizeY="1" data-minSizeX="1" data-minSizeY="1"
            data-maxSizeX="10" data-maxSizeY="10">
            <div class="top-div">
                <div class="dashboard-info alignRow alignColumn">
                    <span>Dashboard 1</span>
                    <span>Malone Group</span>
                </div>
                <div class="info-div alignColumn" *ngIf="startDate && endDate"
                    style="grid-template-columns: 1fr 1fr 1fr;">
                    <span style="font-weight: bold;">Period Start Total</span>
                    <span style="font-weight: bold;">Period End Total</span>
                    <span style="font-weight: bold;">Period Difference</span>
                    <span>{{totalMin}}{{targetSI}}</span>
                    <span>{{totalMax}}{{targetSI}}</span>
                    <span>{{totalDifference}}{{targetSI}}</span>
                </div>
            </div>
        </div>
        <div class="e-panel" data-row="0" data-col="4" data-sizeX="4" data-sizeY="1" data-minSizeX="1" data-minSizeY="1"
            data-maxSizeX="10" data-maxSizeY="10">
            <div class="info-div alignColumn" *ngIf="startDate && endDate" style="grid-template-columns: 1fr 1fr 1fr;">
                <span style="font-weight: bold;">Period Start Point</span>
                <span style="font-weight: bold;">Period End Point</span>
                <span style="font-weight: bold;">Period Length</span>
                <span>{{convertEpoch(startDate.getTime())}}</span>
                <span>{{convertEpoch(endDate.getTime())}}</span>
                <span>{{numDays >= 1 ? numDays : (numDays * 24).toFixed(0)}} {{numDays > 1 ? "Days" : numDays < 1
                        ? "Hours" : "Day" }}</span>
                        <span></span>
                        <span style="font-weight: bold;">Choose Period of Days</span>
                        <span style="font-weight: bold;">Choose Date Range</span>
                        <span><button (click)="saveDashboard()">[test - dashboard]</button></span>
                        <button mat-raised-button [matMenuTriggerFor]="dayMenu" style="margin: auto;">
                            <span>Period Options</span>
                        </button>
                        <button mat-raised-button [matMenuTriggerFor]="timeMenu" style="margin: auto;">
                            <span>Date Range</span>
                            <mat-icon>access_time</mat-icon>
                        </button>
            </div>
        </div>
        <div #gaugeDiv class="e-panel" data-row="1" data-col="0" data-sizeX="2" data-sizeY="2" data-minSizeX="1"
            data-minSizeY="1" data-maxSizeX="10" data-maxSizeY="10">
            <div class="gauge-div alignRow alignColumn">
                <ejs-circulargauge [height]="gaugeHeight" background="transparent" [title]="'Average Values for Period'"
                    [titleStyle]="titleStyle">
                    <e-axes>
                        <e-axis [maximum]="deltaMax" [minimum]="deltaMin" [majorTicks]="majorTicks"
                            [minorTicks]="minorTicks">
                            <e-pointers>
                                <e-pointer [value]="totalAvgPeriod" [color]="periodPointerColour"></e-pointer>
                                <e-pointer [value]="totalAvgRunning" [color]="runningPointerColour"></e-pointer>
                                <e-pointer [value]="recentRunningValue" [color]="currentPointerColour"></e-pointer>
                            </e-pointers>
                        </e-axis>
                    </e-axes>
                </ejs-circulargauge>
                <div class="legend-div">
                    <div class="legend-item alignRow alignColumn">
                        <span class="colour-square" [style.background-color]="runningPointerColour"></span>
                        <span>Running Average - {{totalAvgRunning}}{{targetSI}}</span>
                    </div>
                    <div class="legend-item alignRow alignColumn">
                        <span class="colour-square" [style.background-color]="periodPointerColour"></span>
                        <span>Period Average - {{totalAvgPeriod}}{{targetSI}}</span>
                    </div>
                    <div class="legend-item alignRow alignColumn">
                        <span class="colour-square" [style.background-color]="currentPointerColour"></span>
                        <span>Live Usage - {{recentRunningValue}}{{targetSI}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="e-panel" data-row="1" data-col="2" data-sizeX="2" data-sizeY="2" data-minSizeX="1" data-minSizeY="1"
            data-maxSizeX="10" data-maxSizeY="10">

        </div>
        <div #deltaChartDiv class="e-panel" data-row="3" data-col="0" data-sizeX="4" data-sizeY="2" data-minSizeX="1"
            data-minSizeY="1" data-maxSizeX="10" data-maxSizeY="10" style="position: relative;">
            <button class="graph-change-button" mat-icon-button (click)="toggleShowDeltaBars()">
                <mat-icon>
                    {{showDeltaChartBars ? "show_chart" : "bar_chart"}}
                </mat-icon>
            </button>
            <div class="chart-div">
                <ejs-chart #sumDeltaChart id="sum-delta-chart" [zoomSettings]="zoomSettings" [legendSettings]='legend'
                    [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis" [crosshair]='crosshair'
                    background="#FFFFFF" [border]="borderSettings" [titleStyle]="titleStyle" [palettes]='palette'
                    [height]="deltaChartHeight" [title]="'Usage Over Period'">
                </ejs-chart>
            </div>
        </div>
        <div class="e-panel" data-row="2" data-col="5" data-sizeX="4" data-sizeY="4" data-minSizeX="1" data-minSizeY="1"
            data-maxSizeX="10" data-maxSizeY="10">
            <div class="tree-view">
                <ejs-treeview #treeview id="treeview" [fields]="fields" (nodeExpanded)="nodeExpanded($event)"
                    (nodeCollapsed)="nodeExpanded($event)" (nodeSelected)="selectNode($event)">
                    <ng-template #nodeTemplate="" let-data="">
                        <div class="treeviewdiv">
                            <mat-icon style="float: left; margin-right: 5px;"
                                [ngStyle]="{'color': !isParsableAsNumber(data.Uid) ? 'darkgoldenrod' : ''}">
                                {{(!isParsableAsNumber(data.Uid) && !data.ParentUid) ? "factory"
                                : (!isParsableAsNumber(data.Uid) && data.Expanded==false && data.ParentUid) ? "folder"
                                : (!isParsableAsNumber(data.Uid) && data.Expanded==true && data.ParentUid) ?
                                "folder_opened"
                                : isParsableAsNumber(data.Uid) ? "category" : ""}}
                            </mat-icon>
                            <div class="nodetext" [ngClass]="{'hidden': data.Hidden == true }">
                                <span class="treeName">
                                    {{data.concatenatedText}}</span><span *ngIf="data.Hidden"> (HIDDEN)</span>
                            </div>
                        </div>
                    </ng-template>
                </ejs-treeview>
            </div>
        </div>
    </ejs-dashboardlayout>
</div>

<mat-menu #timeMenu="matMenu">
    <div style="margin: 1em;">
        <!-- <ejs-daterangepicker class="calendar" placeholder="'Pick a date range..." format="dd/MM/yyyy"
            (change)="DatePickerChange($event)" [max]="today" [presets]="datePickerPresets"
            (click)="$event.stopPropagation()"></ejs-daterangepicker> -->
		<app-date-range-picker (datePickerChange)="DatePickerChange($event)"></app-date-range-picker>
    </div>
</mat-menu>

<mat-menu #dayMenu>
    <div style="margin: 1em;">
        <app-duration-selector [(duration)]="strDuration"
            (durationChange)="selectNumDays($event)"></app-duration-selector>
    </div>
</mat-menu>


<!-- kept incase we need it -->

<!-- <div #gaugeDivCurrent class="e-panel" data-row="1" data-col="2" data-sizeX="2" data-sizeY="2" data-minSizeX="1"
            data-minSizeY="1" data-maxSizeX="10" data-maxSizeY="10">
            <div class="gauge-div alignRow alignColumn">
                <ejs-circulargauge [height]="gaugeHeight" background="transparent" [title]="'Current Running Value'"
                    [titleStyle]="titleStyle">
                    <e-axes>
                        <e-axis [maximum]="deltaMax" [minimum]="deltaMin" [majorTicks]="majorTicks"
                            [minorTicks]="minorTicks">
                            <e-pointers>
                                <e-pointer [value]="recentRunningValue" [color]="currentPointerColour"></e-pointer>
                            </e-pointers>
                        </e-axis>
                    </e-axes>
                </ejs-circulargauge>
                <div class="legend-div" style="grid-template-columns: 1fr;">
                    <div class="alignRow" style="margin: auto;">
                        <span class="colour-square" [style.background-color]="currentPointerColour"></span>
                        <span>Current Value ({{targetSI}})</span>
                    </div>
                </div>
            </div>
        </div> -->
<!-- <div #assetCarouselDiv class="e-panel" data-row="1" data-col="4" data-sizeX="4" data-sizeY="2" data-minSizeX="1"
            data-minSizeY="1" data-maxSizeX="10" data-maxSizeY="10">
            <div class="asset-carousel-div alignColumn" *ngIf="energyAssets.length > 0">
                <ejs-carousel #assetCarousel cssClass="default-carousel" indicatorsType="Dynamic" [autoPlay]="autoPlay"
                    [interval]="5000" [buttonsVisibility]="'VisibleOnHover'" [partialVisible]="true"
                    [height]="carouselHeight" [width]="carouselWidth" [selectedIndex]="selectedCarouselIndex"
                    [previousButtonTemplate]="previousButtonTemplate" [nextButtonTemplate]="nextButtonTemplate"
                    [showPlayButton]="true" [playButtonTemplate]="playButtonTemplate">
                    <ng-template #nextButtonTemplate let-data>
                        <button mat-icon-button style="background-color: white;">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </ng-template>
                    <ng-template #previousButtonTemplate let-data>
                        <button mat-icon-button style="background-color: white;">
                            <mat-icon>chevron_left</mat-icon>
                        </button>
                    </ng-template>
                    <ng-template #playButtonTemplate let-data>
                        <button mat-icon-button style="background-color: white;" (click)="autoPlay = !autoPlay">
                            <mat-icon>{{autoPlay ? "pause" : "play_arrow"}}</mat-icon>
                        </button>
                    </ng-template>
                    <e-carousel-items>
                        <e-carousel-item *ngFor="let energyAsset of energyAssets, index as index">
                            <ng-template #template>
                                <div class="energyAsset-Item alignRow alignColumn" [style.height]="carouselHeight">
                                    <div #imgInfoDiv class="img-info">
                                        <img class="assetImage" [height]="imageHeight" style="margin: auto; max-width: 100%;"
                                            src="{{imagePathAssets()}}{{energyAsset.Asset.AssetID}}?{{energyAsset.Asset.Modified}}"
                                            onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
                                            [attr.x-contenttype]="'image/png'" />
                                        <div class="energyAsset-info">
                                            <span style="font-weight: bold;">Asset:</span>
                                            <span>{{energyAsset.Asset.Name}} - {{energyAsset.Asset.Description}}</span>
                                            <span style="font-weight: bold;">Energy DataPoints:</span>
                                            <span>{{getDatapointDPTitles(energyAsset.Datapoints)}}</span>
                                            <button mat-raised-button color="primary" (click)="goToAsset(energyAsset.Asset)">
                                                <span>Go to Asset</span>
                                                <mat-icon>north_east</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <hr style="width: 100%;">
                                    <div class="energyAsset-values" *ngIf="getAsssetEnergyMetrics(energyAsset.Asset.AssetID) as info">
                                        <span style="font-weight: bold;">Current Usage:</span>
                                        <span>{{info.Current}}{{targetSI}}</span>
                                        <span style="font-weight: bold;">Average for Period:</span>
                                        <span>{{info.Avg}}{{targetSI}}</span>
                                        <span style="font-weight: bold;">Running Average for Period:</span>
                                        <span>{{info.RunningAvg}}{{targetSI}}</span>
                                        <span style="font-weight: bold;">Amount Used over Period:</span>
                                        <span>{{info.Diff}}{{targetSI}}</span>
                                        <span style="font-weight: bold;">Total Used:</span>
                                        <span>{{info.Total}}{{targetSI}}</span>
                                    </div>
                                </div>
                            </ng-template>
                        </e-carousel-item>
                    </e-carousel-items>
                </ejs-carousel>
            </div>
        </div> -->
<!-- <div class="e-panel" data-row="3" data-col="6" data-sizeX="4" data-sizeY="2" data-minSizeX="1" data-minSizeY="1"
            data-maxSizeX="10" data-maxSizeY="10">
            <div class="chart-div">
                <ejs-chart #sumTotalChart id="sum-total-chart" [zoomSettings]="zoomSettings" [legendSettings]='legend'
                    [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis" [crosshair]='crosshair'
                    background="#FFFFFF" [border]="borderSettings" [titleStyle]="titleStyle" [palettes]='palette'
                    [height]="deltaChartHeight" [title]="'Total Value Over Period'">
                </ejs-chart>
            </div>
        </div> -->
<!-- <div class="e-panel" data-row="0" data-col="0" data-sizeX="4" data-sizeY="1" data-minSizeX="1" data-minSizeY="1"
            data-maxSizeX="10" data-maxSizeY="10">
            <div class="info-div alignColumn" *ngIf="startDate && endDate">
                <span style="font-weight: bold;">Period Start Total</span>
                <span style="font-weight: bold;">Period End Total</span>
                <span style="font-weight: bold;">Period Difference</span>
                <span style="font-weight: bold;">Period Start Point</span>
                <span style="font-weight: bold;">Period End Point</span>
                <span style="font-weight: bold;">Period Length</span>
                <span>{{totalMin}}{{targetSI}}</span>
                <span>{{totalMax}}{{targetSI}}</span>
                <span>{{totalDifference}}{{targetSI}}</span>
                <span>{{convertEpoch(startDate.getTime())}}</span>
                <span>{{convertEpoch(endDate.getTime())}}</span>
                <span>{{numDays >= 1 ? numDays : (numDays * 24).toFixed(0)}} {{numDays > 1 ? "Days" : numDays < 1 ? "Hours" : "Day"}}</span>
                <span style="font-weight: bold;">Period Average Running Value</span>
                <span style="font-weight: bold;">Period Average Value</span>
                <span style="font-weight: bold;">Current Running Value</span>
                <span style="font-weight: bold;">Number of Assets</span>
                <span style="font-weight: bold;">Choose Period of Days</span>
                <span style="font-weight: bold;">Choose Date Range</span>
                <span class="highlighted-info"
                    [style.background-color]="runningPointerColour">{{totalAvgRunning}}{{targetSI}}</span>
                <span class="highlighted-info"
                    [style.background-color]="periodPointerColour">{{totalAvgPeriod}}{{targetSI}}</span>
                <span class="highlighted-info"
                    [style.background-color]="currentPointerColour">{{recentRunningValue}}{{targetSI}}</span>
                <span>{{energyAssets.length}}</span>
                <button mat-raised-button [matMenuTriggerFor]="dayMenu" style="margin: auto;">
                    <span>Period Options</span>
                </button>
                <button mat-raised-button [matMenuTriggerFor]="timeMenu" style="margin: auto;">
                    <span>Date Range</span>
                    <mat-icon>access_time</mat-icon>
                </button>
            </div>
        </div> -->